"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Flickr;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Flickr(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("style", {
    dangerouslySetInnerHTML: {
      __html: ".cls-1{fill:#010101;}"
    }
  })), /*#__PURE__*/_react["default"].createElement("title", null, "Flickr"), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Social_media",
    "data-name": "Social media"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "flickr",
    className: "cls-1",
    d: "M81.429,10H18.571A8.573,8.573,0,0,0,10,18.571V81.429A8.573,8.573,0,0,0,18.571,90H81.429A8.573,8.573,0,0,0,90,81.429V18.571A8.573,8.573,0,0,0,81.429,10ZM35.8,61.25A11.34,11.34,0,1,1,47.143,49.911,11.333,11.333,0,0,1,35.8,61.25Zm28.392,0a11.34,11.34,0,1,1,11.34-11.339A11.332,11.332,0,0,1,64.2,61.25Z"
  })));
}